var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2641_33213",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 1,
    width: 31,
    height: 33
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4999 2.9165L21.3302 5.71067L26.0719 5.70192L27.5281 10.214L31.3693 12.9936L29.8957 17.4998L31.3693 22.0061L27.5281 24.7857L26.0719 29.2978L21.3302 29.289L17.4999 32.0832L13.6695 29.289L8.92777 29.2978L7.47162 24.7857L3.63037 22.0061L5.10402 17.4998L3.63037 12.9936L7.47162 10.214L8.92777 5.70192L13.6695 5.71067L17.4999 2.9165Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3955 17.4998L16.0413 21.1457L23.333 13.854",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2641_33213)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H35V35H0V0Z",
    fill: "#2C8A57"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.a92dbbad874f7493c16806d7828aaf0c.svg";
export { ForwardRef as ReactComponent };